module.exports = __webpack_public_path__ + "img/page8_choice_bac.a6bd4753.png";